import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import {
  AddIngredientPayload,
  ChangeIngredientPayload,
  EntryMethodsKeys,
  MixerDataInIngredient,
  PreviewRationCreation,
  SourceType,
  TargetWeights,
} from './appRecipes.types';
import { Recipe } from '../../entities/recipes/recipes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/appRecipe');

export const setEditModeInRecipeCreation = actionCreator<boolean>('SET_EDIT_MODE_IN_RECIPE_CREATION');
export const setAutoAdjWater = actionCreator<boolean>('SET_AUTO_ADJ_WATER');
export const setTargetWeightType = actionCreator<TargetWeights>('SET_TARGET_WEIGHT_TYPE');
export const setMethod = actionCreator<EntryMethodsKeys>('SET_METHOD');
export const setWaterAmount = actionCreator<number>('SET_WATER_AMOUNT');
export const addIngredientInRecipe = actionCreator<AddIngredientPayload>('ADD_INGREDIENT_IN_RECIPE');
export const addIngredientInRecipeSilent = actionCreator<AddIngredientPayload>('ADD_INGREDIENT_IN_RECIPE_SILENT');
export const deleteIngredientInRecipe = actionCreator<{ id: string }>('DELETE_INGREDIENT_IN_RECIPE');
export const emptyIngredientsInRecipe = actionCreator('EMPTY_INGREDIENT_IN_RECIPE');
export const setSelectedIngredientInList = actionCreator<string | null>('SET_SELECTED_INGREDIENT_IN_LIST');
export const updateIngredientOrderInRecipe = actionCreator<any>('UPDATE_INGREDIENT_ORDER_IN_RECIPE');
export const addRecipeTransitionDays = actionCreator<number>('ADD_RECIPE_TRANSITION_DAYS');
export const setCurrentTransitionDay = actionCreator<number>('SET_CURRENT_TRANSITION_DAY');
export const editCurrentTransitionDay = actionCreator<number>('EDIT_CURRENT_TRANSITION_DAY');
export const deleteCurrentTransionDay = actionCreator<void>('DELETE_CURRENT_TRANSITION_DAY');
export const recalculateFixedDates = actionCreator<number>('RECALCULATE_FIXED_DATES');
export const setTableView = actionCreator<'grid' | 'graph'>('SET_TABLE_VIEW');

export const setEditRecipe = actionCreator<Recipe & { baseRation: Recipe }>('SET_EDIT_RECIPE');

export const updateMixerData = actionCreator<{ listId: string; mixerData: MixerDataInIngredient }>('UPDATE_MIXER_DATA');
export const updateActualLoad = actionCreator<{ listId: string; actualLoad: number }>('UPDATE_ACTUAL_LOAD');
export const updateDryMatter = actionCreator<{ listId: string; dryMatter: number }>('UPDATE_DRY_MATTER');
export const updateActualLoadPercentage = actionCreator<{ listId: string; actualLoadPercentage: number }>(
  'UPDATE_ACTUAL_LOAD_PERCENTAGE',
);
export const updateDryMatterPercentage = actionCreator<{ listId: string; dryMatterPercentage: number }>(
  'UPDATE_DRY_MATTER_PERCENTAGE',
);
export const setActualLoadTargetWeight = actionCreator<number>('SET_ACTUAL_LOAD_TARGET_WEIGHT');
export const setDryMatterTargetWeight = actionCreator<number>('SET_DRY_MATTER_TARGET_WEIGHT');

export const sendRecipePayload = actionCreator<{}>('SEND_RECIPE_PAYLOAD');
export const previewCreateRecipe = actionCreator.async<{}, PreviewRationCreation, any>('PREVIEW_CREATE_RECIPE');
export const updateBaseRationRecipe = actionCreator.async<{ recipeId: string }, Recipe>('UPDATE_BASE_RATION_RECIPE');
export const updateBaseRationPerc = actionCreator<{ perc: number }>('UPDATE_BASE_RATION_PERC');
export const updateBaseRationActualLoad = actionCreator<{ baseActualLoad: number; source: SourceType }>(
  'UPDATE_BASE_RATION_ACTUAL_LOAD',
);
export const updateBaseRationDryMatter = actionCreator<{ baseDryMatter: number; source: SourceType }>(
  'UPDATE_BASE_RATION_DRY_MATTER',
);
export const updateBaseRationActualLoadPercentage = actionCreator<{
  baseActualLoadPercentage: number;
  source: SourceType;
}>('UPDATE_BASE_RATION_ACTUAL_LOAD_PERCENTAGE');
export const updateBaseRationDryMatterPercentage = actionCreator<{
  baseDryMatterPercentage: number;
  source: SourceType;
}>('UPDATE_BASE_RATION_DRY_MATTER_PERCENTAGE');

export const updateRecipeTypeId = actionCreator<number>('UPDATE_RECIPE_TYPE_ID');

export const changeIngredient = actionCreator.async<ChangeIngredientPayload, ChangeIngredientPayload>(
  'CHANGE_INGREDIENT',
);

export const updateRefusalSubstitute =
  actionCreator<{ uuid: string; refusalSubstitute: boolean }[]>('UPDATE_REFUSAL_SUBSTITUTE');
